
const digest = 'de9b737ede88d8541be7275b2c56cb0f3abf36fe63f20e6bb9e117344955e8d9';
const classes = {"wrapper":"_wrapper_grq55_1","titleWrapper":"_titleWrapper_grq55_15","title":"_title_grq55_15","content":"_content_grq55_25"};
const css = `._wrapper_grq55_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #000000;
  background: #ffffff;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  border-bottom: 0;
}
._wrapper_grq55_1:last-of-type {
  border-bottom: 1px solid #eaedf3;
}
._wrapper_grq55_1 ._titleWrapper_grq55_15 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
._wrapper_grq55_1 ._titleWrapper_grq55_15 ._title_grq55_15 {
  font-weight: 600;
  font-size: 14px;
}
._wrapper_grq55_1 ._content_grq55_25 {
  font-size: 14px;
  font-weight: 400;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  